import { StoryCard, StoryCardPollContent } from '../../services';

interface PollVoteReducerArgs {
  card: StoryCard;
  selectedVoteIds: string[];
}

export const pollVoteReducer = ({ card, selectedVoteIds }: PollVoteReducerArgs) => {
  const content = card.content as StoryCardPollContent;

  content.selectedVoteIds = selectedVoteIds;

  content.totalVotes += 1;

  content.voteResults = content.voteResults.map((voteResult) => {
    if (selectedVoteIds.includes(voteResult.id)) {
      return { ...voteResult, count: voteResult.count + 1 };
    }

    return voteResult;
  });
};
